import categoryService from "../../../services/ticketService/categoryService";
import { CategoryInterface } from "../../../models/TicketModule/Category";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_CATEGORIES } from "../../../utils/constants";

interface AddCategoriesContext {
  previousCategories: CategoryInterface[];
}

const useAddCategories = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<
    CategoryInterface,
    Error,
    CategoryInterface,
    AddCategoriesContext
  >({
    mutationFn: categoryService.Save,

    onMutate: () => {
      const previousCategories =
        queryClient.getQueryData<CategoryInterface[]>([
          CACHE_KEY_CATEGORIES,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ]) || [];

      return { previousCategories };
    },

    onSuccess: (savedCategory) => {
      queryClient.setQueryData<CategoryInterface[]>(
        [
          CACHE_KEY_CATEGORIES,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ],
        (categories) =>
          categories ? [savedCategory, ...categories] : [savedCategory]
      );
    },

    onError: (error, newCategory, context) => {
      if (!context) return;

      queryClient.setQueryData<CategoryInterface[]>(
        [
          CACHE_KEY_CATEGORIES,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ],
        context.previousCategories
      );
    },
  });
};

export default useAddCategories;
